import React, { FC } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import SignupHeader from './header'
import './styles.scss'

interface Props extends RouteComponentProps {
  page?: string
}

const SignupLayout: FC<Props> = props => {
  const { children, page = '' } = props
  return (
    <div className="signup-layout">
      <SignupHeader />
      <div className={`signup-body ${page}`}>{children}</div>
    </div>
  )
}

export default withRouter(SignupLayout)
